/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  AccountId,
  FilterUnitRegistrationId,
  HttpValidationProblemDetails,
  RegistrationCompositeId,
  SegmentationId,
  SparePartRegistrationId,
  SparePartRegistrationRequest
} from './data.schemas'




export const createSparePartRegistration = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    filterUnitId: FilterUnitRegistrationId,
    sparePartRegistrationRequest: SparePartRegistrationRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/filter-units/${encodeURIComponent(String(filterUnitId))}/spare-parts`,
      sparePartRegistrationRequest,options
    );
  }



export const getCreateSparePartRegistrationMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSparePartRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: SparePartRegistrationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createSparePartRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: SparePartRegistrationRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSparePartRegistration>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: SparePartRegistrationRequest}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,filterUnitId,data} = props ?? {};

          return  createSparePartRegistration(segmentationId,accountId,registrationCompositeId,filterUnitId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSparePartRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof createSparePartRegistration>>>
    export type CreateSparePartRegistrationMutationBody = SparePartRegistrationRequest
    export type CreateSparePartRegistrationMutationError = AxiosError<HttpValidationProblemDetails | string>

    export const useCreateSparePartRegistration = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSparePartRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: SparePartRegistrationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createSparePartRegistration>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: SparePartRegistrationRequest},
        TContext
      > => {

      const mutationOptions = getCreateSparePartRegistrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const updateSparePartRegistration = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    filterUnitId: FilterUnitRegistrationId,
    sparePartId: SparePartRegistrationId,
    sparePartRegistrationRequest: SparePartRegistrationRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.put(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/filter-units/${encodeURIComponent(String(filterUnitId))}/spare-parts/${encodeURIComponent(String(sparePartId))}`,
      sparePartRegistrationRequest,options
    );
  }



export const getUpdateSparePartRegistrationMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSparePartRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;sparePartId: SparePartRegistrationId;data: SparePartRegistrationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateSparePartRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;sparePartId: SparePartRegistrationId;data: SparePartRegistrationRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSparePartRegistration>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;sparePartId: SparePartRegistrationId;data: SparePartRegistrationRequest}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,filterUnitId,sparePartId,data} = props ?? {};

          return  updateSparePartRegistration(segmentationId,accountId,registrationCompositeId,filterUnitId,sparePartId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSparePartRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof updateSparePartRegistration>>>
    export type UpdateSparePartRegistrationMutationBody = SparePartRegistrationRequest
    export type UpdateSparePartRegistrationMutationError = AxiosError<HttpValidationProblemDetails | string>

    export const useUpdateSparePartRegistration = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSparePartRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;sparePartId: SparePartRegistrationId;data: SparePartRegistrationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateSparePartRegistration>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;sparePartId: SparePartRegistrationId;data: SparePartRegistrationRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSparePartRegistrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteSparePartRegistration = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    filterUnitId: FilterUnitRegistrationId,
    sparePartId: SparePartRegistrationId, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.delete(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/filter-units/${encodeURIComponent(String(filterUnitId))}/spare-parts/${encodeURIComponent(String(sparePartId))}`,options
    );
  }



export const getDeleteSparePartRegistrationMutationOptions = <TError = AxiosError<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSparePartRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;sparePartId: SparePartRegistrationId}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSparePartRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;sparePartId: SparePartRegistrationId}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSparePartRegistration>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;sparePartId: SparePartRegistrationId}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,filterUnitId,sparePartId} = props ?? {};

          return  deleteSparePartRegistration(segmentationId,accountId,registrationCompositeId,filterUnitId,sparePartId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSparePartRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSparePartRegistration>>>
    
    export type DeleteSparePartRegistrationMutationError = AxiosError<string>

    export const useDeleteSparePartRegistration = <TError = AxiosError<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSparePartRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;sparePartId: SparePartRegistrationId}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteSparePartRegistration>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;sparePartId: SparePartRegistrationId},
        TContext
      > => {

      const mutationOptions = getDeleteSparePartRegistrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    